import axios from "axios";
import store from "../store"

axios.defaults.headers.post['Accept'] = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/json'

// 요청 인터셉터 추가
axios.interceptors.request.use(
  function (config) {
    store.commit('START_LOADING');
    // 요청을 보내기 전에 수행할 일
    // console.log('axios request interceptors ', config)
    return config;
  },
  function (error) {
    // 오류 요청을 보내기전 수행할 일    
    return Promise.reject(error);
  }
);

// 응답 인터셉터 추가
axios.interceptors.response.use(
  function (response) { 
    // 응답 데이터를 가공
    store.commit('END_LOADING');
    return response;
  },
  function (error) { // 오류 응답을 처리
    store.commit('END_LOADING');
    //토큰오류 일경우 
    let originalRequest = error.config
    let response = error.response;

    console.log('axios error', error.response)
    // 400,
    if (
      typeof error.response != 'undefined' 
      && [401].includes(response.status) 
      ) 
    {
      console.log('axios error 401')
      // response.data
      // {
      //   code: "",
      //   date: "",
      //   detail: "",
      //   message: "",
      //   status: 401,
      // }

      if (
        !originalRequest.url.includes('refreshToken')
        && !originalRequest._retry 
        && typeof error.response.data != 'undefined'
        && typeof error.response.data.code != 'undefined'
        && error.response.data.code == "AU002"
        ) 
      {
        // console.log("axios error 401 LOGIN_REFRESH") 
        originalRequest._retry = true
        return store.dispatch('LOGIN_REFRESH', originalRequest);
      } 

      // console.log("axios error 401 LOGOUT_EXPIRE or REFRESH_TOKEN_EXPIRE") 
      store.dispatch('LOGOUT')
      return Promise.reject(error);
    } 

    return Promise.reject(error);
  }
);

export default axios;
